import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppFirmaDigital = Loadable(lazy(() => import('./view/listado/FirmaDigital')))
export const firmaDigitalRoutesMap = {
  gestion: {
    path: '/firmaDigital/gestion',
    name: 'Firma Digital',
  },
}

const firmaDigitalRoutes = [
  {
    path: firmaDigitalRoutesMap.gestion.path,
    element: <AppFirmaDigital />,
    auth: authRoles.admin,
  },
]

export default firmaDigitalRoutes
